import { IocQueryDefinition, IocQueryId } from "./ioc-queries";
import "./ioc-query-nav.scss";

interface IocQueryNavProps {
  queries: IocQueryDefinition[];
  selectedQueryId: IocQueryId;
  onSelectQuery: (queryId: IocQueryId) => void;
}

function IocQueryNav(props: IocQueryNavProps) {
  const { queries, selectedQueryId, onSelectQuery } = props;

  return (
    <nav className="patient-records-query-nav" aria-label="IOC queries">
      <h2 className="query-nav-title">Queries</h2>
      <ul className="query-nav-list">
        {queries.map((query) => {
          const isSelected = query.id === selectedQueryId;
          return (
            <li key={query.id} className="query-nav-item">
              <button
                type="button"
                className={`query-nav-button${isSelected ? " selected" : ""}`}
                aria-current={isSelected ? "page" : undefined}
                onClick={() => onSelectQuery(query.id)}
              >
                {query.label}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export default IocQueryNav;
